import Vue from 'vue'
import template from './index.pug'
import Frame63 from 'assets/images/info-bono/Frame 63.svg'
import Frame65 from 'assets/images/info-bono/Frame 65.svg'
import LogoGE from 'assets/images/logo.svg'
import LogoGC from 'assets/images/logo_prod_GC.png'

export default Vue.extend({
  template: template(), 
  
  components: {
  },

  computed: {
  },

  data() {
    return {
      frame63:Frame63,
      frame65:Frame65,
      logoGe:LogoGE,
      logoGc:LogoGC
    }
  },

  methods: {
  }
})